import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FileV2Api } from '@schenck/rotec-components';
import { map } from 'rxjs/operators';

@Injectable()
export class PictureService {
  private readonly fileApi = inject(FileV2Api);

  getPicture$(id: string): Observable<File> {
    return this.fileApi.get$({ id });
  }

  getPictureUrl$(id: string): Observable<string> {
    return this.getPicture$(id).pipe(map((picture) => URL.createObjectURL(picture)));
  }
}
